import { CreatePracticeFeedbackRequest } from "@shared/dtos/requests/practiceFeedbackRequests.dto"
import { PracticeFeedbackResponse } from "@shared/dtos/responses/practiceFeedbackResponses.dto"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

/** Create feedback for a practice */
export const create = async (
  practiceId: string,
  data: CreatePracticeFeedbackRequest
): Promise<PracticeFeedbackResponse> => {
  const resp = await axiosAuth({
    url: `/practices/${practiceId}/feedback`,
    method: "post",
    data,
  })
  return resp.data
}

/** Find all feedback given for a practice */
export const findAll = async (practiceId: string): Promise<PracticeFeedbackResponse[]> => {
  const resp = await axiosAuth({
    url: `/practices/${practiceId}/feedback`,
    method: "get",
  })
  return resp.data
}
